import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const gamePlanSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getGamePlan: builder.query({
            query: (arg: any) => {
                const { employeenumber } = arg;
                return {
                    url: constants.GET_GAME_PLAN,
                    params: { employeenumber },
                };
            },
            providesTags: ['coachingInsightHistory'],
        }),
        getGameplanScorecardSummary: builder.query({
            query: (arg: any) => {
                const { employeeNumber, year, month, intervalMonthsBack } = arg;
                return {
                    url: constants.GET_GAMEPLAN_SCORECARD_SUMMARY,
                    params: { employeeNumber, year, month, intervalMonthsBack },
                };
            },
            // providesTags: ['coachingInsightHistory'],
        }),
        getGameplanCASummary: builder.query({
            query: (arg: any) => {
                const { employeeNumber, year, month, intervalMonthsBack } = arg;
                return {
                    url: constants.GET_GAMEPLAN_CA_SUMMARY,
                    params: { employeeNumber, year, month, intervalMonthsBack },
                };
            },
        }),
        getGameplanStrengthSummary: builder.query({
            query: (arg: any) => {
                const { employeeNumber, year, month, intervalMonthsBack } = arg;
                return {
                    url: constants.GET_GAMEPLAN_STRENGTH_SUMMARY,
                    params: { employeeNumber, year, month, intervalMonthsBack },
                };
            },
        }),
        getGameplanConversationSummary: builder.query({
            query: (arg: any) => {
                const { employeeNumber, year, month, intervalMonthsBack } = arg;
                return {
                    url: constants.GET_GAMEPLAN_CONVERSATION_SUMMARY,
                    params: { employeeNumber, year, month, intervalMonthsBack },
                };
            },
        }),
    }),
});

export const {
    useGetGamePlanQuery,
    useGetGameplanScorecardSummaryQuery,
    useGetGameplanCASummaryQuery,
    useGetGameplanStrengthSummaryQuery,
    useGetGameplanConversationSummaryQuery,
} = gamePlanSlice;
